import React from 'react'
import Panorama from './components/Panorama'

export default function PanoramaContainer() {
  return (
    <Panorama></Panorama> 
  )
}
